// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const buscarEtiquetasService = async () => {
  const Token = validateToken();

  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/etiqueta`;

    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });

      if (response && response.data) {
        return response.data;

        // Retorna true se tudo correr bem e o array não estiver vazio
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
